import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./TaxiForSaleMoreInfotable.css";

const TaxiForSaleMoreInfotable = () => {
    const { id } = useParams();
    const [taxi, setTaxi] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get("/api/taxiforsale")
            .then(res => {
                const foundTaxi = res.data.find(item => item.id === id);
                if (foundTaxi) {
                    setTaxi(foundTaxi);
                } else {
                    setError("❌ המונית לא נמצאה");
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("❌ שגיאה בשליפת הנתונים:", err);
                setError("❌ לא ניתן לטעון את הנתונים");
                setLoading(false);
            });
    }, [id]);

    if (loading) return <p>🔄 טוען נתונים...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="taxi-table-container">
            <h2 className="table-title">פרטים נוספים</h2>
            {taxi && (
                <div className="taxi-details">
                    <div className="detail-row">
                        <span className="detail-label">יד:</span>
                        <span className="detail-value">{taxi["יד"]}</span>
                        <span className="detail-label">קילומטראז':</span>
                        <span className="detail-value">{taxi["קמ"]}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">שנתון:</span>
                        <span className="detail-value">{taxi["שנתון"]}</span>
                        <span className="detail-label">תאריך עלייה לכביש:</span>
                        <span className="detail-value">{new Date(taxi["תאריך_עלייה_לכביש"]).toLocaleDateString()}</span>
                    </div>
                    <div className="detail-row">
<span className="detail-label">מחיר לא כולל מע"מ:</span>
<span className="detail-value">
  {Number(taxi["מחיר"]) <= 4
    ? "פורסם ללא מחיר"
    : `${taxi["מחיר"]} ₪`}
</span>

                        <span className="detail-label">טסט:</span>
                        <span className="detail-value">{taxi["טסט"]}</span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">טלפון:</span>
                        <span className="detail-value">{taxi["טלפון"]}</span>
                        <span className="detail-label">וואטסאפ:</span>
                        <span className="detail-value">
                            <a href={taxi["קישור_וואטסאפ"]} target="_blank" rel="noopener noreferrer">לחץ כאן</a>
                        </span>
                    </div>
                    <div className="detail-row">
                        <span className="detail-label">בעלות פרטית / מגרש:</span>
                        <span className="detail-value">{taxi["בעלות"]}</span>
                        <span className="detail-label">אזור מגורים:</span>
                        <span className="detail-value">{taxi["אזור_מגורים"]}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TaxiForSaleMoreInfotable;